var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardPlanDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Account/Plan Details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 25 0 25 24.7676 0 24.7676"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Account/Plan-Details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3179,11.6153 L10.5029,12.8783 C10.2559,13.0503 9.9299,12.8133 10.0169,12.5253 L10.6569,10.4093 C10.6959,10.2813 10.6509,10.1433 10.5449,10.0633 L8.7839,8.7273 C8.5429,8.5453 8.6679,8.1623 8.9689,8.1563 L11.1789,8.1113 C11.3119,8.1083 11.4299,8.0233 11.4729,7.8973 L12.1989,5.8093 C12.2979,5.5253 12.7009,5.5253 12.7999,5.8093 L13.5259,7.8973 C13.5699,8.0233 13.6869,8.1083 13.8199,8.1113 L16.0299,8.1563 C16.3319,8.1623 16.4559,8.5453 16.2159,8.7273 L14.4539,10.0633 C14.3479,10.1433 14.3029,10.2813 14.3419,10.4093 L14.9819,12.5253 C15.0689,12.8133 14.7429,13.0503 14.4959,12.8783 L12.6809,11.6153 C12.5719,11.5393 12.4269,11.5393 12.3179,11.6153",
    id: "Fill-1",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.334,22.544 L13.094,21.33 C12.776,21.211 12.425,21.209 12.105,21.324 L8.665,22.563 L8.665,18.532 L16.334,18.532 L16.334,22.544 Z M21.284,0 L3.722,0 C1.67,0 0,1.67 0,3.722 L0,5.963 C0,6.516 0.447,6.963 1,6.963 C1.553,6.963 2,6.516 2,5.963 L2,3.722 C2,2.773 2.772,2 3.722,2 L21.284,2 C22.23,2 23,2.77 23,3.716 L23,14.862 C23,15.783 22.25,16.532 21.329,16.532 L3.688,16.532 C2.758,16.532 2,15.774 2,14.844 L2,11.094 C2,10.541 1.553,10.094 1,10.094 C0.447,10.094 0,10.541 0,11.094 L0,14.844 C0,16.878 1.654,18.532 3.688,18.532 L6.665,18.532 L6.665,23.254 C6.665,23.747 6.906,24.21 7.31,24.493 C7.567,24.675 7.872,24.768 8.18,24.768 C8.353,24.768 8.525,24.738 8.692,24.678 L12.588,23.275 L16.288,24.662 C16.756,24.837 17.275,24.772 17.683,24.488 C18.091,24.205 18.334,23.739 18.334,23.243 L18.334,18.532 L21.329,18.532 C23.354,18.532 25,16.886 25,14.862 L25,3.716 C25,1.667 23.333,0 21.284,0 L21.284,0 Z",
    id: "Fill-3",
    fill: "#282827"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPlanDetails);
export default __webpack_public_path__ + "static/media/dashboard_plan_details.abe7a8c14221c8b681307215aa06601a.svg";
export { ForwardRef as ReactComponent };